import { restClient } from '../config/restClient'

const endpoint = interviewRequestId => `/api/company/v2/interview_requests/${interviewRequestId}`

export const getInterviewRequestCompetition = async interviewRequestId => {
  const response = await restClient(`${endpoint(interviewRequestId)}/competition`, {
    method: 'GET',
  })
  return response.data
}
